import { Component, Input } from '@angular/core';
import {Slide} from '../../../slide/slide.model';

@Component({
    selector: 'image-quiz',
    templateUrl: 'image-quiz.component.html'
})
export class PreviewImageQuizComponent {
    private _resultData: {
        contentIndex: number,
        questionLength: number 
    };
    private _slide: Slide;
    @Input('resultData') 
    set resultData(resultData) {
        this._resultData = resultData;
    }
    get resultData() {
        return this._resultData;
    }
    @Input('slide') 
    set slide(slide) {
        this._slide = slide;
    }
    get slide() {
        return this._slide;
    }

    constructor() {}
    getCaption(mobile) {
        if( !this.slide ) {
            return '';
        }
        if( this.resultData ) {
            const image = this.slide.content[this.resultData.contentIndex]['image'];
            if( !image ) {
                return '';
            }
            return image.caption;
        }
        if( mobile && this.slide.imagesMobile.length > 0 ) {
            return this.slide.imagesMobile[0].caption;
        }
        if( this.slide.images.length > 0 ) {
            return this.slide.images[0].caption;
        }
    }
    getScore() {
        const { contentIndex, questionLength } = this.resultData;
        const resultLength = this.slide.content.length;
        let scoreText = 'You scored 0 out of ' + questionLength;
        if( contentIndex > 0 ) {
            let tier = (contentIndex / resultLength);
            let score = Math.round(tier * questionLength);
            scoreText = 'You scored ' + score + ' out of ' + questionLength;
        }
        return scoreText;
    }
    getNextText() {
        if( this.slide.intro ) {
            return 'Start Quiz';
        }
        if( this.slide.outro ) {
            return 'Next Quiz';
        }
        return 'Next';
    }
}